import React from "react";

import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";
import {useAppDispatch} from "../../../../../app/hooks";
import {showErrorToastNotification, showInfoToastNotification, showSuccessToastNotification} from "../../../toastNotification/toastNotificationSlice";
import {KnowledgeDefinitionKind} from "../../../../modules/knowledge/knowledgeDefinitionsApi";
import {deleteKnowledgeDefinition} from "../../../../modules/knowledge/knowledgeDefinitionsSlice";
import {KNOWLEDGE_DEFINITION_LABELS} from "../../../../modules/knowledgeSettings/knowledgeDefinitionLabels";

interface ConfirmationModalProps {
    publicId: string
    handleClose: (value?: any) => any
    kind: KnowledgeDefinitionKind
    entityName?: string
}

export const DeleteKnowledgeDefinitionConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                                 publicId,
                                                                                                 handleClose,
                                                                                                 kind,
                                                                                                 entityName
                                                                                             }) => {
    const dispatch = useAppDispatch()
    const labels = KNOWLEDGE_DEFINITION_LABELS[kind]

    const handleDelete = async () => {
        handleClose()
        dispatch(showInfoToastNotification({message: `Deleting ${labels.singular}. We'll notify you once it's done.`}))
        try {
            await dispatch(deleteKnowledgeDefinition({kind, publicId})).unwrap()
            dispatch(showSuccessToastNotification({message: `${labels.capitalised} deleted successfully`}))
        } catch (message: any) {
            // The platform explains a refused delete, e.g. "Knowledge type is used by 3 knowledge records".
            dispatch(showErrorToastNotification({
                message: typeof message === "string" && message
                    ? message
                    : `Failed to delete the ${labels.singular}. Please try again.`
            }))
        }
    }

    return <ConfirmationModal
        title={`Delete the ${labels.singular}`}
        subtitle={`Are you sure you want to delete this ${labels.singular}? ${labels.deleteWarning} You won't be able to undo this action.`}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={"Yes, delete"}
        onConfirm={handleDelete}
        onClose={handleClose}
        confirmationText={entityName}
    />
}
